import React, { useEffect, useState } from 'react';
import emptyFolter from '../../../../assets/images/empty-folder 2.svg';
import { ExpandMore } from '@mui/icons-material';
import DoneIcon from '@mui/icons-material/Done';
import Searchicon from '../../../../assets/images/Search.svg';
import {
  TextField,
  Button,
  Select,
  IconButton,
  FormGroup,
  InputLabel,
  Grid,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Chip,
  Typography,
} from '@mui/material';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import {
  Remove as MinusIcon,
  ArrowDropDown,
  ArrowDropUp,
} from '@mui/icons-material';
import { useHook as ControllerHook } from '../controllerPage/useHook';
import { useHook as RoleHook } from '../../Iam/rolemanagement/useHook';
import { useHook as EquipmentHook } from './useHook';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { closeIcon } from '../../../../assets/images/index';
import { setGetControllerDetails } from '../../../../stores/actionTypes/controllerActions';
import { UrlToBase } from '../../../../components/urlToBase64';
import UnsavedChangesPopup from './UnsavedChangesPopup';
import EquipmentDetails from '../../customerManagement/equipmentDetail';
const EquipmentsParamEdit = (props: any) => {
  const { editData, formSubmit,setEquipmentsPage,setEquipmentsPayload,equipmentsPayload } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { controllerAllList, controllerDetails } = useSelector(
    (state: any) => state.controller,
  );
  const [filteredControllerData, setFilteredControllerData] =
    useState<any>(controllerAllList);
  const [selectedControllerData, setSelectedControllerData] =
    useState<string>('');
  const { fetchAllControllerList, fetchGetControllerDetails } =
    ControllerHook();
  const { fetchGetAllRoleList } = RoleHook();
  const { createEquipment, editEquipment } = EquipmentHook();
  const [formData, setFormData] = useState({
    parameterName: '',
    parameterComment: '',
    unit: '',
    decimals: 2,
    minValue: '',
    maxValue: '',
    defaultValue: 0,
    customerAccess: false,
    order: 0,
    dealerAccess: false,
    primary: false,
  });
  const [controllerParameter, setControllerParameter] = useState<any>([]);
  const [expanded, setExpanded] = useState<number[]>([]);
  const [expandedForm, setExpandedForm] = useState<number[]>([]);
  const { allRole } = useSelector((state: any) => state.role);
  const [tagName, setTagName] = React.useState<string[]>([]);
  const [filteredRoles, setFilteredRoles] = useState<any[]>([]);
  const [selectedRole, setSelectedRole] = useState<string[]>([]);
  const [isActiveParam, setIsActiveParam] = useState(false);
  const [isActiveSubmitParam, setIsActiveSubmitParam] = useState(false);
  const [croppedImage, setCroppedImages] = useState<string | null>(null);
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);
 const [isUnsavedChangesDialogOpen, setIsUnsavedChangesDialogOpen] =
    useState<any>(false);
  const handleUnsavedClose = () => {
    setIsUnsavedChangesDialogOpen(false);
  };
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string>
  >({});
  const [cotrollerOpen, setCotrollerOpen] = useState(false);
  const [activeEditedData, setActiveEditedData] = useState<number[]>([]);

  const handleCloseCotroller = () => {
    setCotrollerOpen(false);
    setFilteredControllerData(controllerAllList);
  };

  const getControllerList = async () => {
    await fetchAllControllerList({});
  };
  useEffect(() => {
    if (!(controllerAllList?.length > 0)) {
      getControllerList();
    }
    if (!(allRole?.length > 0)) {
      fetchGetAllRoleList({});
    }
    dispatch(setGetControllerDetails({}));
  }, []);

  useEffect(() => {
    setFilteredControllerData(controllerAllList);
  }, [controllerAllList]);

  useEffect(() => {
    if (editData) {
      setSelectedControllerData(editData?.controller?.controllerID);
      const addmissingValue = editData?.controller?.parameters?.map(
        (obj: any) => {
          return {
            order: obj?.order ? obj?.order : 0,
            decimals: obj?.decimals ? obj?.decimals : 2,
            minValue: obj?.minValue ? obj?.minValue : '0',
            maxValue: obj?.maxValue ? obj?.maxValue : '0',
            defaultValue: obj?.defaultValue ? obj?.defaultValue : 0,
            primary: obj?.controllerVariable
              ? obj?.controllerVariable === editData?.primaryParameter
              : false,
            ...obj,
          };
        },
      );
      setControllerParameter(addmissingValue);
    }
  }, [editData]);

  useEffect(() => {
    const paramData = {
      unit: 'A',
      decimals: 2,
      minValue: '0',
      maxValue: '0',
      defaultValue: 0,
      order: 0,
    };

    if (controllerDetails?.parameters) {
      const addedParamData = controllerDetails?.parameters?.map((obj: any) => {
        return {
          controllerVariable: obj?.variableName,
          parameterName: obj?.name,
          parameterComment: obj?.comment,
          accessPermissions: obj?.accessPermissions,
          customerAccess: obj?.customerAccess,
          behaviour: obj?.behaviour,
          ...paramData, // Spread the paramData values to add
        };
      });
      setControllerParameter(addedParamData);
    } else {
      if (editData) {
        const addmissingValue = editData?.controller?.parameters?.map(
          (obj: any) => {
            return {
              order: obj?.order ? obj?.order : 0,
              decimals: obj?.decimals ? obj?.decimals : 2,
              minValue: obj?.minValue ? obj?.minValue : '0',
              maxValue: obj?.maxValue ? obj?.maxValue : '0',
              defaultValue: obj?.defaultValue ? obj?.defaultValue : 0,
              primary: obj?.controllerVariable
                ? obj?.controllerVariable === editData?.primaryParameter
                : false,
              ...obj,
            };
          },
        );
        setControllerParameter(addmissingValue);
      }
    }
  }, [controllerDetails]);

  useEffect(() => {
    setFilteredRoles(allRole);
  }, [allRole]);

  const findrolename = (roleid: string) => {
    if (allRole?.length > 0) {
      if (roleid) {
        const findrole = allRole.find((param: any) => param.roleID == roleid);
        return findrole?.roleName ? findrole?.roleName : roleid;
      } else {
        return roleid;
      }
    } else {
      return roleid;
    }
  };

  const handleControllSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query: string = event.target.value.toLowerCase();
    const filtered: any = controllerAllList?.filter((user: any) =>
      user?.controllerName?.toLowerCase().includes(query),
    );

    setFilteredControllerData(filtered);
  };

  const handleChangeTagName = (event: any) => {
    const {
      target: { value },
    } = event;
    setTagName(typeof value === 'string' ? value.split(',') : value);
    setIsActiveParam(true);
  };

  const handleUserSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.toLowerCase();
    const filtered = allRole?.filter((role: { roleName: string }) =>
      role.roleName?.toLowerCase().includes(query),
    );
    setFilteredRoles(filtered);
  };

  const handleRoleSelection = (roleName: string | undefined) => {
    if (!roleName) return;
    setSelectedRole((prevselectedRole) => {
      if (prevselectedRole.includes(roleName)) {
        const updatedRoles = prevselectedRole.filter(
          (roles) => roles !== roleName,
        );
        return updatedRoles;
      } else {
        const updatedRoles = [...prevselectedRole, roleName];
        return updatedRoles;
      }
    });
    handleremoveError('role');
    setSeeMoreIndex(2);
  };

  const handleControllDisplay = async (controllerID: any) => {
    if (controllerID) {
      setSelectedControllerData(controllerID);
      if (editData && editData?.controller?.controllerID === controllerID) {
        setControllerParameter(editData?.controller?.parameters);
      } else {
        await fetchGetControllerDetails({ controllerID });
      }
    } else {
      setSelectedControllerData('');
    }
    setExpandedForm([]);
    setExpanded([]);
    setValidationErrors({});
    setIsActiveParam(false);
    setIsActiveSubmitParam(true);
  };

  const validateForm = () => {
    const errors: Record<string, string> = {};

    if (formData.parameterName.trim() === '') {
      errors.parameterName = 'Name is required';
    }
    if (formData.unit.trim() === '') {
      errors.unit = 'Unit is required';
    }
    if (formData?.decimals?.toString().trim() === '') {
      errors.decimals = 'Decimals is required';
    }
    if (formData?.order?.toString().trim() === '') {
      errors.order = 'Order is required';
    }
    // if (formData?.defaultValue?.toString().trim() === ''|| !formData?.defaultValue) {
    //   errors.defaultValue = 'DefaultValue is required';
    // }
    const defaultValue = formData.defaultValue;
    // Convert value to a number
    const numericValue = Number(defaultValue);
    // Check if the value is a number (including 0) and is not empty
    if (defaultValue === undefined || defaultValue === null) {
      errors.defaultValue = 'DefaultValue is required';
    } else if (isNaN(numericValue)) {
      errors.defaultValue = 'DefaultValue must be a valid number';
    }
    // if (Number(formData?.minValue) >= Number(formData?.maxValue)) {
    //   errors.minValue = 'Min value should be less than Max value';
    //   errors.maxValue = 'Max value should be greater than Min value';
    // }

    if (formData.minValue.trim() === '') {
      errors.minValue = 'minValue is required';
    }
    if (formData.maxValue.trim() === '') {
      errors.maxValue = 'MaxValue is required';
    }
    if (!(selectedRole?.length > 0)) {
      errors.role = 'Roles is required';
    }

    setValidationErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const submitedParam = (event: any) => {
    event.preventDefault();
    if (validateForm()) {
      const ParamData = {
        ...formData,
        accessPermissions: selectedRole,
      };
      // const updatedParamData: any[] = [...controllerParameter]; // Create a copy of the state array

      // updatedParamData[expandedForm[0]] = ParamData; // Update the specific element

      let activePrimaryindex: number | undefined; // Declare it as undefined initially

      const removeOtherReadableAccessData = controllerParameter?.map(
        (data: any, index: number) => {
          if (data?.primary) {
            activePrimaryindex = index;
          }
          return {
            ...data,
            primary: ParamData?.primary ? false : data?.primary ? true : false,
          };
        },
      );
      if (activePrimaryindex !== undefined && ParamData?.primary) {
        setActiveEditedData((prev: any) => [
          ...prev,
          ...expandedForm,
          activePrimaryindex,
        ]);
      } else {
        setActiveEditedData((prev: any) => [...prev, ...expandedForm]);
      }

      removeOtherReadableAccessData[expandedForm[0]] = ParamData; // Update the specific element
      setControllerParameter(removeOtherReadableAccessData); // Update the state with the modified array
      setExpandedForm([]);
      setIsActiveSubmitParam(true);
    }
  };

  const handleremoveError = (name: string) => {
    if (!name) return;
    // const updateError = { ...validationErrors };
    // delete updateError[name];
    // setValidationErrors(updateError);

    // Create a copy of the current validation errors
    setValidationErrors((prevErrors) => {
      // Use a new object to avoid mutating the previous state directly
      const { [name]: _, ...updatedErrors } = prevErrors;
      return updatedErrors;
    });
  };

  const handleChange = (event: { target: { name: any; value: any } }) => {
    const { name, value } = event.target;
    if (name === 'decimals' || name === 'order') {
      if (/^\d*\.?\d*$/.test(value)) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: Number(value),
        }));
      }
    } else if (name === 'defaultValue') {
      const isDecimal = /^\d*\.?\d*$/; // Regular expression to allow decimal values
      if (isDecimal.test(value)) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: parseFloat(value),
        }));
      }
    } else if (['maxValue', 'minValue'].includes(name)) {
      const isMinusAndDecimal = /^-?\d*\.?\d*$/;
      if (isMinusAndDecimal.test(value)) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    if (name === 'maxValue') {
      handleremoveError('minValue');
    } else if (name === 'minValue') {
      handleremoveError('maxValue');
    }
    setIsActiveParam(true);
    handleremoveError(name);
  };

  const handleChangeCustomerAccess = (event: {
    target: { name: any; checked: boolean };
  }) => {
    const { name, checked } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
    setIsActiveParam(true);
  };

  const toggleExpanded = (index: number) => {
    if (expandedForm?.includes(index)) {
      setExpandedForm([]);
    } else {
      if (expanded?.includes(index)) {
        const removedExpand = expanded.filter((item: number) => item !== index);
        setExpanded(removedExpand);
      } else {
        setExpanded([...expanded, index]);
      }
    }
    setValidationErrors({});
    setIsActiveParam(false);
  };

  const toggleFormExpanded = (index: number) => {
    if (expandedForm?.includes(index)) {
      setExpandedForm([]);
    } else {
      setExpandedForm([index]);
    }
    const removedExpand = expanded.filter((item: number) => item !== index);
    setExpanded(removedExpand);
    setValidationErrors({});
    setIsActiveParam(false);
  };

  useEffect(() => {
    if (editData) {
      const imageUrl = editData?.image;
      if (imageUrl) {
        UrlToBase(imageUrl)
          .then((base64String) => {
            setCroppedImages(base64String);
          })
          .catch((error) => console.error(error));
      }
    }
  }, [editData]);


  
  const handleSubmitEquipment = async () => {
    setIsActiveSubmitParam(false);
    const createPayload = {
      controllerID: selectedControllerData,
      parameters: controllerParameter,
    };
    if (editData) {
      const imageType = croppedImage?.substring(11, croppedImage?.indexOf(';'));
      const imageWithoutPrefix = croppedImage?.substring(
        croppedImage?.indexOf(',') + 1,
      );
      let primaryParameter = '';
      controllerParameter?.forEach((data: any) => {
        if (data?.primary) {
          primaryParameter = data?.controllerVariable;
        }
        // // Remove 'primary' key from the object
        // delete data.primary;
      });
      const editEquipmentPayload = {
        equipmentID: editData?.equipmentID,
        equipmentName: editData?.name,
        model: editData?.model,
        image: imageWithoutPrefix ? imageWithoutPrefix : '',
        ext: imageType ? imageType : '',
        category: editData?.category,
        subCategory: editData?.subCategory,
        primaryParameter,
        controller: {
          controllerID: selectedControllerData,
          parameters: controllerParameter,
        },
      };
      await editEquipment({...editData,...editEquipmentPayload});
      navigate(-1);
    } else {
      // formSubmit(createPayload);

   

       const payload = {
      ...equipmentsPayload,
      controller: {
        controllerID: createPayload?.controllerID,
        parameters: createPayload?.parameters,
      },
    };

    

     setEquipmentsPayload(payload);
    setEquipmentsPage('addAlerts');
    }
    setActiveEditedData([]);
  };

  return (
    <>
      <div className="hardware-equipment">
        <div className="equipment-controller">
          {!editData && (
            <>
              <div className="equipment_controller-header">
                <div className="equipment-controller_header-content">
                  <h4>Select Controller</h4>
                </div>
                <div className="equipment-controller_header-select">
                  <Select
                    open={cotrollerOpen}
                    onOpen={() => setCotrollerOpen(true)}
                    onClose={() => {
                      handleCloseCotroller();
                    }}
                    className="equipment_header-select"
                    multiple
                    displayEmpty
                    value={controllerAllList}
                    renderValue={() => (
                      <div className="selecter_dropdown_placeholder">
                        {selectedControllerData?.length === 0 ? (
                          'Select Controller'
                        ) : (
                          <p>{`${controllerAllList?.find((controller: { controllerID: string }) => controller?.controllerID === selectedControllerData)?.controllerName}`}</p>
                        )}
                      </div>
                    )}
                    IconComponent={ExpandMore}
                  >
                    <div className="user_name-popover equipment-header_select-popover ">
                      <div className="user_name-popover-search">
                        <TextField
                          className="user_name-popover-search_input search-input"
                          variant="outlined"
                          placeholder="Select Controller names here"
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <img
                                src={Searchicon}
                                className="search_icon"
                                alt="Search Icon"
                              />
                            ),
                          }}
                          onChange={handleControllSearch}
                        />
                      </div>
                      {filteredControllerData?.map(
                        (
                          user: { controllerID: string; controllerName: any },
                          index: React.Key | null | undefined,
                        ) => (
                          <Button
                            key={index}
                            onClick={() => {
                              handleControllDisplay(user?.controllerID);
                              handleCloseCotroller();
                            }}
                            className={
                              selectedControllerData === user?.controllerID
                                ? 'global_audilog_user user_checked'
                                : 'global_audilog_user'
                            }
                          >
                            <div className="global_audilog_user_profile">
                              <p>{`${user?.controllerName}`}</p>
                            </div>
                            {selectedControllerData === user?.controllerID && (
                              <IconButton className="iconButton">
                                <DoneIcon className="doneIcon" />
                              </IconButton>
                            )}
                          </Button>
                        ),
                      )}
                    </div>
                  </Select>
                </div>
              </div>
              <div className="equipment_controller-line"></div>
            </>
          )}

          <div className="equipment_controller-body">
            {!selectedControllerData &&
            Object.keys(controllerDetails)?.length == 0 ? (
              <div className="global_audilog-nodata">
                <img src={emptyFolter} alt="nodata" width="120" height="120" />
                <h3>No Record Found!</h3>
              </div>
            ) : (
              <div className="equipment-body_Parameters">
                <h5>
                  {`${controllerDetails?.controllerName || controllerAllList?.find((controller: { controllerID: string }) => controller?.controllerID === selectedControllerData)?.controllerName || ' '} Parameters`}{' '}
                </h5>
                {controllerParameter?.map((param: any, index: number) => (
                  <div key={index} className="equipment-body_Parameters-param">
                    <div className="equipment-body_Parameters-param-header">
                      <div className="equipment-body_Parameters-content">
                        <IconButton
                          className="category_expanded-btn"
                          onClick={() => toggleExpanded(index)}
                        >
                          {expanded?.includes(index) ||
                          expandedForm?.includes(index) ? (
                            <ArrowDropUp />
                          ) : (
                            <ArrowDropDown />
                          )}
                        </IconButton>
                        <h4>{param?.parameterName}</h4>
                        {param?.behaviour && (
                          <div
                            className={
                              param?.behaviour?.toLowerCase() === 'read'
                                ? 'read_data equipments_Parameters_status-data'
                                : 'write_data equipments_Parameters_status-data'
                            }
                          >
                            {param?.behaviour}
                          </div>
                        )}
                        {param?.primary && (
                          <div className="write_data equipments_Parameters_status-data">
                            primary
                          </div>
                        )}
                        {activeEditedData.includes(index) && (
                          <div className="active_edit_data-dot"></div>
                        )}
                      </div>
                      {!expandedForm?.includes(index) && (
                        <Button
                          className="btn-transparent border-0 img-background-form"
                          onClick={() => {
                            toggleFormExpanded(index);
                            setFormData(param);
                            setSelectedRole(param?.accessPermissions);
                            setSeeMoreIndex(2);
                          }}
                        >
                          <i className="edit-icon bi bi-pencil-square bi-lg"></i>
                        </Button>
                      )}
                    </div>
                    {expanded.includes(index) &&
                      !expandedForm.includes(index) && (
                        <div className="equipment-body_Parameters-values">
                          <div className="equipment-body_Parameters-param-values-data">
                            <div className="equipment-body_Parameters-data">
                              <h5>Parameters Name</h5>
                              <h4>{param?.parameterName}</h4>
                            </div>
                            <div className="equipment-body_Parameters-data">
                              <h5>Parameter Comment</h5>
                              <h4>{param?.parameterComment}</h4>
                            </div>
                            <div className="equipment-body_Parameters-data">
                              <h5>Unit</h5>
                              <h4>{param?.unit}</h4>
                            </div>
                          </div>
                          <div className="equipment-body_Parameters-param-values-data">
                            <div className="equipment-body_Parameters-data">
                              <h5>Decimals</h5>
                              <h4>{param?.decimals}</h4>
                            </div>
                            <div className="equipment-body_Parameters-data">
                              <h5>Min Value</h5>
                              <h4>{param?.minValue}</h4>
                            </div>
                            <div className="equipment-body_Parameters-data">
                              <h5>Max Value</h5>
                              <h4>{param?.maxValue}</h4>
                            </div>
                          </div>
                          <div className="equipment-body_Parameters-param-values-data">
                            <div className="equipment-body_Parameters-data">
                              <h5>Default Value</h5>
                              <h4>{param?.defaultValue}</h4>
                            </div>
                            <div className="equipment-body_Parameters-data">
                              <h5>Access Permission</h5>
                              <h4>
                                {' '}
                                {param?.accessPermissions
                                  ?.map(findrolename)
                                  .join(', ')}
                              </h4>
                            </div>
                            <div className="equipment-body_Parameters-data">
                              <h5>Order</h5>
                              <h4> {param?.order}</h4>
                            </div>
                          </div>
                          <div className="equipment-body_Parameters-param-values-data">
                            <div className="equipment-body_Parameters-data">
                              <FormGroup className="equipment-body_Parameters-param-field-input">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={param?.customerAccess || false}
                                    />
                                  }
                                  label="Customer Access"
                                />
                              </FormGroup>
                            </div>
                            <div className="equipment-body_Parameters-data">
                              <FormGroup className="equipment-body_Parameters-param-field-input">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={param?.dealerAccess || false}
                                    />
                                  }
                                  label="Dealer Access"
                                />
                              </FormGroup>
                            </div>
                            <div className="equipment-body_Parameters-data">
                              <FormGroup className="equipment-body_Parameters-param-field-input">
                                {param?.behaviour?.toLowerCase() === 'read' && (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={param?.primary || false}
                                      />
                                    }
                                    label="Primary Access"
                                  />
                                )}
                              </FormGroup>
                            </div>
                          </div>
                        </div>
                      )}
                    {expandedForm.includes(index) &&
                      !expanded.includes(index) && (
                        <div>
                          <form onSubmit={submitedParam}>
                            <div className="equipment-body_Parameters-param-field">
                              <FormGroup className="equipment-body_Parameters-param-field-input">
                                <InputLabel>Parameters Name</InputLabel>
                                <TextField
                                  id="parameterName"
                                  name="parameterName"
                                  value={formData?.parameterName}
                                  onChange={handleChange}
                                  error={
                                    validationErrors?.parameterName
                                      ? true
                                      : false
                                  }
                                />
                                {validationErrors?.parameterName && (
                                  <Typography
                                    variant="body2"
                                    className="text-danger"
                                  >
                                    {validationErrors?.parameterName}
                                  </Typography>
                                )}
                              </FormGroup>
                              <FormGroup className="equipment-body_Parameters-param-field-input">
                                <InputLabel>Parameter Comment</InputLabel>
                                <TextField
                                  id="parameterComment"
                                  name="parameterComment"
                                  value={formData?.parameterComment}
                                  onChange={handleChange}
                                />
                              </FormGroup>
                              <FormGroup className="equipment-body_Parameters-param-field-input">
                                <InputLabel>Unit</InputLabel>
                                <TextField
                                  id="unit"
                                  name="unit"
                                  value={formData?.unit}
                                  onChange={handleChange}
                                  error={validationErrors?.unit ? true : false}
                                />
                                {/* <Select
                                  labelId="select-label"
                                  className="create_controller-nodata_drawer_form_field_input"
                                  id="unit"
                                  name="unit"
                                  value={formData?.unit}
                                  onChange={handleChange}
                                  IconComponent={ExpandMore}
                                  error={validationErrors?.unit ? true : false}
                                >
                                  <MenuItem value="A">A</MenuItem>
                                </Select> */}
                                {validationErrors?.unit && (
                                  <Typography
                                    variant="body2"
                                    className="text-danger"
                                  >
                                    {validationErrors?.unit}
                                  </Typography>
                                )}
                              </FormGroup>
                            </div>

                            <div className="equipment-body_Parameters-param-field">
                              <FormGroup className="equipment-body_Parameters-param-field-input">
                                <InputLabel>Decimals</InputLabel>
                                <TextField
                                  id="decimals"
                                  name="decimals"
                                  value={Number(formData?.decimals)}
                                  onChange={handleChange}
                                  error={
                                    validationErrors?.decimals ? true : false
                                  }
                                />
                                {validationErrors?.decimals && (
                                  <Typography
                                    variant="body2"
                                    className="text-danger"
                                  >
                                    {validationErrors?.decimals}
                                  </Typography>
                                )}
                              </FormGroup>
                              <FormGroup className="equipment-body_Parameters-param-field-input">
                                <InputLabel>Min Value</InputLabel>
                                <TextField
                                  id="minValue"
                                  name="minValue"
                                  value={formData?.minValue}
                                  onChange={handleChange}
                                  error={
                                    validationErrors?.minValue ? true : false
                                  }
                                />
                                {validationErrors?.minValue && (
                                  <Typography
                                    variant="body2"
                                    className="text-danger"
                                  >
                                    {validationErrors?.minValue}
                                  </Typography>
                                )}
                              </FormGroup>
                              <FormGroup className="equipment-body_Parameters-param-field-input">
                                <InputLabel>Max Value</InputLabel>
                                <TextField
                                  id="maxValue"
                                  name="maxValue"
                                  value={formData?.maxValue}
                                  onChange={handleChange}
                                  error={
                                    validationErrors?.maxValue ? true : false
                                  }
                                />
                                {validationErrors?.maxValue && (
                                  <Typography
                                    variant="body2"
                                    className="text-danger"
                                  >
                                    {validationErrors?.maxValue}
                                  </Typography>
                                )}
                              </FormGroup>
                            </div>

                            <div className="equipment-body_Parameters-param-field">
                              <FormGroup className="equipment-body_Parameters-param-field-input">
                                <InputLabel>Default Value</InputLabel>
                                <TextField
                                  id="defaultValue"
                                  name="defaultValue"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      step: '0.01', // Set the step to handle decimal precision
                                      min: '0', // Set minimum value if needed
                                    },
                                  }}
                                  value={formData?.defaultValue}
                                  onChange={handleChange}
                                  error={
                                    validationErrors?.defaultValue
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    param?.behaviour?.toLowerCase() === 'read'
                                      ? true
                                      : false
                                  }
                                />
                                {validationErrors?.defaultValue && (
                                  <Typography
                                    variant="body2"
                                    className="text-danger"
                                  >
                                    {validationErrors?.defaultValue}
                                  </Typography>
                                )}
                              </FormGroup>

                              <FormGroup className=" equipment-body_Parameters-param-field-input">
                                <InputLabel>Access Permission</InputLabel>
                                <Select
                                  multiple
                                  displayEmpty
                                  value={tagName}
                                  onChange={handleChangeTagName}
                                  error={validationErrors?.role ? true : false}
                                  renderValue={() => (
                                    <div className="selecter_dropdown_placeholder">
                                      Select Role
                                    </div>
                                  )}
                                  IconComponent={ExpandMore}
                                >
                                  <div className="selectoption_content">
                                    <div className="selectoption_search_content">
                                      <TextField
                                        className="selectoption_searchbar search-input"
                                        variant="outlined"
                                        placeholder="Search user"
                                        fullWidth
                                        InputProps={{
                                          startAdornment: (
                                            <SearchIcon className="search_icon" />
                                          ),
                                        }}
                                        onChange={handleUserSearch}
                                      />
                                    </div>
                                    <div className="selectoption_list_content">
                                      {filteredRoles.map((role, index) => (
                                        <div
                                          key={index}
                                          className="selectoption_list"
                                        >
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                checked={selectedRole.includes(
                                                  String(role.roleID),
                                                )}
                                                onChange={() => {
                                                  handleRoleSelection(
                                                    String(role.roleID),
                                                  );
                                                }}
                                              />
                                            }
                                            label={role.roleName}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </Select>
                                <div className="select_Role_Chip-data">
                                  {selectedRole
                                    ?.slice(0, seeMoreIndex)
                                    ?.map((value) => (
                                      <Chip
                                        key={value}
                                        label={findrolename(value)}
                                        deleteIcon={
                                          <img
                                            src={closeIcon}
                                            alt="Delete Icon"
                                            width={13}
                                          />
                                        }
                                        onDelete={() => {
                                          setSelectedRole(
                                            selectedRole.filter(
                                              (val) => val !== value,
                                            ),
                                          );
                                          setIsActiveParam(true);
                                        }}
                                        className="form_selectchip"
                                      />
                                    ))}
                                  {selectedRole?.length > 2 &&
                                    seeMoreIndex === 2 && (
                                      <div className="see_more_data">
                                        <Button
                                          onClick={() =>
                                            setSeeMoreIndex(
                                              selectedRole?.length,
                                            )
                                          }
                                        >{`+${selectedRole?.length - 2} More`}</Button>
                                      </div>
                                    )}
                                </div>
                                {validationErrors?.role && (
                                  <Typography
                                    variant="body2"
                                    className="text-danger"
                                  >
                                    {validationErrors?.role}
                                  </Typography>
                                )}
                              </FormGroup>

                              <FormGroup className="equipment-body_Parameters-param-field-input">
                                <InputLabel>Order</InputLabel>
                                <TextField
                                  id="order"
                                  name="order"
                                  value={Number(formData?.order)}
                                  onChange={handleChange}
                                  error={validationErrors?.order ? true : false}
                                />
                                {validationErrors?.order && (
                                  <Typography
                                    variant="body2"
                                    className="text-danger"
                                  >
                                    {validationErrors?.order}
                                  </Typography>
                                )}
                              </FormGroup>
                            </div>

                            <div className="equipment-body_Parameters-param-field">
                              <FormGroup className="equipment-body_Parameters-param-field-input customer_access_checkbox">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      id="customerAccess"
                                      name="customerAccess"
                                      checked={formData?.customerAccess}
                                      onChange={handleChangeCustomerAccess}
                                      // onChange={(e: any) => {
                                      //   handleParamChange(e);
                                      //   handleActiveChange();
                                      // }}
                                    />
                                  }
                                  label="Customer Access"
                                />
                              </FormGroup>
                              <FormGroup className="equipment-body_Parameters-param-field-input customer_access_checkbox">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      id="dealerAccess"
                                      name="dealerAccess"
                                      checked={formData?.dealerAccess}
                                      onChange={handleChangeCustomerAccess}
                                      // onChange={(e: any) => {
                                      //   handleParamChange(e);
                                      //   handleActiveChange();
                                      // }}
                                    />
                                  }
                                  label="Dealer Access"
                                />
                              </FormGroup>

                              <FormGroup className="equipment-body_Parameters-param-field-input customer_access_checkbox">
                                {param?.behaviour?.toLowerCase() === 'read' && (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        id="primary"
                                        name="primary"
                                        checked={formData?.primary}
                                        onChange={handleChangeCustomerAccess}
                                        // onChange={(e: any) => {
                                        //   handleParamChange(e);
                                        //   handleActiveChange();
                                        // }}
                                      />
                                    }
                                    label="Primary"
                                  />
                                )}
                              </FormGroup>
                            </div>

                            <div className="equipment-body_Parameters-param-footer-btn">
                              <div className="equipment-body_Parameters-param-buttons">
                                <Button
                                  variant="text"
                                  className="cencel_button"
                                  onClick={() => setExpandedForm([])}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant="contained"
                                  className={
                                    isActiveParam
                                      ? 'save_button'
                                      : 'save_button disabled_button'
                                  }
                                  type="submit"
                                  disabled={!isActiveParam}
                                >
                                  {editData ? 'Update' : 'Save'}
                                </Button>
                              </div>
                            </div>
                          </form>
                        </div>
                      )}
                  </div>
                ))}
              </div>
            )}
          </div>
          {expandedForm?.length === 0 && (
            <div className="create_controller_form-submit create_equipment_form-submit">
              <Button
                className="create_controller_form-cancel-btn"
                onClick={editData && activeEditedData.length>0 ? 
                  ()=> setIsUnsavedChangesDialogOpen(true):

                  () => navigate(-1)}
              >
                Cancel
              </Button>
              <Button
                className={
                  isActiveSubmitParam && expandedForm?.length === 0
                    ? 'create_controller_form-submit-btn'
                    : 'disable_controller-btn'
                }
                disabled={!isActiveSubmitParam || expandedForm?.length !== 0}
                onClick={handleSubmitEquipment}
              >
                {/* {editData ? 'Save Changes' : 'Create'} */}
                        {editData ? 'Save Changes' : 'Next'}
              </Button>
            </div>
          )}
        </div>
      </div>

           <UnsavedChangesPopup
        open={isUnsavedChangesDialogOpen}
        handleClose={handleUnsavedClose}
        handleNavigateClick={() => navigate(-1)}
      />
    </>
  );
};
const MemoizedComponent = React.memo(EquipmentsParamEdit);
export default MemoizedComponent;
